import React from "react";
import {Outlet} from "react-router-dom";
import Menu from "routes/Menu";

const Alerts = () => {
  Menu(6);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Alerts;
